// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var ErrorType;
(function (ErrorType) {
    ErrorType["ERROR_TYPE_UNKNOWN"] = "ERROR_TYPE_UNKNOWN";
    ErrorType["ERROR_TYPE_VALIDATION"] = "ERROR_TYPE_VALIDATION";
    ErrorType["ERROR_TYPE_PARTNER"] = "ERROR_TYPE_PARTNER";
    ErrorType["ERROR_TYPE_SKIP"] = "ERROR_TYPE_SKIP";
})(ErrorType || (ErrorType = {}));
export var ErrorType_index;
(function (ErrorType_index) {
    ErrorType_index[ErrorType_index["ERROR_TYPE_UNKNOWN"] = 0] = "ERROR_TYPE_UNKNOWN";
    ErrorType_index[ErrorType_index["ERROR_TYPE_VALIDATION"] = 1] = "ERROR_TYPE_VALIDATION";
    ErrorType_index[ErrorType_index["ERROR_TYPE_PARTNER"] = 2] = "ERROR_TYPE_PARTNER";
    ErrorType_index[ErrorType_index["ERROR_TYPE_SKIP"] = 3] = "ERROR_TYPE_SKIP";
})(ErrorType_index || (ErrorType_index = {}));
export var ValidationErrorCode;
(function (ValidationErrorCode) {
    ValidationErrorCode["UNKNOWN_VALIDATION_ERROR"] = "UNKNOWN_VALIDATION_ERROR";
    ValidationErrorCode["MISSING_MEMBER_ID"] = "MISSING_MEMBER_ID";
    ValidationErrorCode["MISSING_FIRST_NAME"] = "MISSING_FIRST_NAME";
    ValidationErrorCode["MISSING_LAST_NAME"] = "MISSING_LAST_NAME";
    ValidationErrorCode["MISSING_PAYER_ID"] = "MISSING_PAYER_ID";
    ValidationErrorCode["MISSING_DOB"] = "MISSING_DOB";
    ValidationErrorCode["MISSING_NPI"] = "MISSING_NPI";
    ValidationErrorCode["NOT_SUPPORTED_PAYER"] = "NOT_SUPPORTED_PAYER";
})(ValidationErrorCode || (ValidationErrorCode = {}));
export var ValidationErrorCode_index;
(function (ValidationErrorCode_index) {
    ValidationErrorCode_index[ValidationErrorCode_index["UNKNOWN_VALIDATION_ERROR"] = 0] = "UNKNOWN_VALIDATION_ERROR";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_MEMBER_ID"] = 1] = "MISSING_MEMBER_ID";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_FIRST_NAME"] = 2] = "MISSING_FIRST_NAME";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_LAST_NAME"] = 3] = "MISSING_LAST_NAME";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_PAYER_ID"] = 4] = "MISSING_PAYER_ID";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_DOB"] = 5] = "MISSING_DOB";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_NPI"] = 6] = "MISSING_NPI";
    ValidationErrorCode_index[ValidationErrorCode_index["NOT_SUPPORTED_PAYER"] = 7] = "NOT_SUPPORTED_PAYER";
})(ValidationErrorCode_index || (ValidationErrorCode_index = {}));
export const InsuranceVerificationAdapterService = {
    GetDentalCoverageInfo(fn, req) {
        return fn(`/insurance-verification/v2/dental-coverage-info`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetCachedDentalCoverageInfoByPersonId(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v2/person/${req["personId"]}/dental-coverage-info?${fm.renderURLSearchParams(req, ["personId"])}`, { method: "GET" });
    },
    GetCoverageStatusCountsByOrg(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v2/org/${req["orgId"]}/status/count?${fm.renderURLSearchParams(req, ["orgId"])}`, { method: "GET" });
    },
};
